import {
  __decorateClass
} from "./chunk-QUKACBNK.js";

// src/router.ts
var tabs = document.querySelector("sp-tabs");
tabs.addEventListener("change", (event) => {
  const target = event.target;
  const { selected } = target;
  const { pathname } = location;
  const isAPI = pathname.search("api") > -1;
  const isChangelog = pathname.search("changelog") > -1;
  const parseURLRegex = /\/api\/?|\/changelog\/?/;
  switch (selected) {
    case "api": {
      if (isAPI) {
        return;
      }
      const dest = pathname.replace(parseURLRegex, "/") + "api/";
      history.pushState({}, document.title, dest);
      break;
    }
    case "changelog": {
      if (isChangelog) {
        return;
      }
      const dest = pathname.replace(parseURLRegex, "/") + "changelog/";
      history.pushState({}, document.title, dest);
      break;
    }
    case "overview": {
      if (!isAPI && !isChangelog) {
        return;
      }
      const dest = pathname.replace(parseURLRegex, "/");
      history.pushState({}, document.title, dest);
      break;
    }
  }
});

// ../../../node_modules/@lit-labs/observers/resize-controller.js
var s = class {
  constructor(s2, { target: t, config: i, callback: h, skipInitial: e }) {
    this.t = /* @__PURE__ */ new Set(), this.o = false, this.i = false, this.h = s2, null !== t && this.t.add(t ?? s2), this.l = i, this.o = e ?? this.o, this.callback = h, window.ResizeObserver ? (this.u = new ResizeObserver((s3) => {
      this.handleChanges(s3), this.h.requestUpdate();
    }), s2.addController(this)) : console.warn("ResizeController error: browser does not support ResizeObserver.");
  }
  handleChanges(s2) {
    this.value = this.callback?.(s2, this.u);
  }
  hostConnected() {
    for (const s2 of this.t) this.observe(s2);
  }
  hostDisconnected() {
    this.disconnect();
  }
  async hostUpdated() {
    !this.o && this.i && this.handleChanges([]), this.i = false;
  }
  observe(s2) {
    this.t.add(s2), this.u.observe(s2, this.l), this.i = true, this.h.requestUpdate();
  }
  unobserve(s2) {
    this.t.delete(s2), this.u.unobserve(s2);
  }
  disconnect() {
    this.u.disconnect();
  }
};

// src/components/demo-container.ts
import {
  html,
  SpectrumElement
} from "@spectrum-web-components/base";
import {
  customElement,
  property,
  query
} from "@spectrum-web-components/base/src/decorators.js";

// src/components/demo-container.css
import { css } from "lit";
var styles = css`:host([scrollable]){overflow:auto;place-content:start center!important}.wrapper{width:var(--demo-container-width,max-content);max-width:580px;margin:0 auto}`;
var demo_container_default = styles;

// src/components/demo-container.ts
var DemoContainer = class extends SpectrumElement {
  constructor() {
    super(...arguments);
    this.scrollable = false;
    this.resizeController = new s(this, {
      callback: () => this.shouldUpdateScrollableState()
    });
    this.shouldUpdateScrollableState = () => {
      const { offsetHeight, scrollHeight } = this;
      this.scrollable = offsetHeight < scrollHeight;
    };
  }
  static get styles() {
    return [demo_container_default];
  }
  render() {
    return html`
      <div class="wrapper">
        <slot></slot>
      </div>
    `;
  }
  firstUpdated() {
    this.resizeController.observe(this.wrapper);
  }
};
__decorateClass([
  property({ type: Boolean, reflect: true })
], DemoContainer.prototype, "scrollable", 2);
__decorateClass([
  query(".wrapper")
], DemoContainer.prototype, "wrapper", 2);
DemoContainer = __decorateClass([
  customElement("demo-container")
], DemoContainer);

// src/components.ts
import "@spectrum-web-components/tabs/sp-tab-panel.js";
import "@spectrum-web-components/tabs/sp-tab.js";
import "@spectrum-web-components/tabs/sp-tabs.js";
import "@spectrum-web-components/top-nav/sp-top-nav.js";
import "@spectrum-web-components/top-nav/sp-top-nav-item.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-add.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-remove.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-magnify.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-help.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-info.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-star.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-chevron-down.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-close.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-info.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-checkmark.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-checkmark-circle.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-alert.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-edit.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-more.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-settings.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-save-floppy.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-stopwatch.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-user-activity.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-anchor-select.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-polygon-select.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-rect-select.js";
import "@spectrum-web-components/table/sp-table.js";
import "@spectrum-web-components/table/sp-table-body.js";
import "@spectrum-web-components/table/sp-table-cell.js";
import "@spectrum-web-components/table/sp-table-checkbox-cell.js";
import "@spectrum-web-components/table/sp-table-head.js";
import "@spectrum-web-components/table/sp-table-head-cell.js";
import "@spectrum-web-components/table/sp-table-row.js";
import "@spectrum-web-components/field-group/sp-field-group.js";
import "@spectrum-web-components/field-label/sp-field-label.js";
import "@spectrum-web-components/textfield/sp-textfield.js";
import "@spectrum-web-components/number-field/sp-number-field.js";
import "@spectrum-web-components/card/sp-card.js";
import "@spectrum-web-components/icon/sp-icon.js";
if ("requestIdleCallback" in window) {
  requestIdleCallback(() => {
    import("@spectrum-web-components/bundle/elements.js");
    import("@spectrum-web-components/grid/sp-grid.js");
  });
} else {
  requestAnimationFrame(() => {
    import("@spectrum-web-components/bundle/elements.js");
    import("@spectrum-web-components/grid/sp-grid.js");
  });
}
var StyledElement = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: block;
                    background-color: var(--spectrum-gray-50);
                    color: var(--spectrum-gray-800);
                    border: 1px solid;
                    padding: 2em;
                }
            </style>
            <slot></slot>
        `;
  }
};
customElements.define("styled-element", StyledElement);
document.querySelector('sp-tab-panel[value="api"]')?.addEventListener("click", (event) => {
  const path = event.composedPath();
  const row = path.find(
    (el) => el.localName === "sp-table-row" && el.id
  );
  if (row) {
    location.hash = row.id;
    event.target.dispatchEvent(
      new CustomEvent("copy-text", {
        bubbles: true,
        composed: true,
        detail: {
          text: row.dataset.value,
          message: `${row.dataset.name} copied to clipboard!`
        }
      })
    );
  }
});
